import { dataService } from "../services/data.services";
import { userService } from "../services/user.services";
import { clearAuthSession, setAuthItem } from './authSession';

export const CheckUserStatus = async()=>{

    let user=true;

    try {
        const user1 = await dataService.GetAPI('providers/check-status');
        setAuthItem('custom-status', user1?.data?.data?.user_status);
        if (user1?.data?.data?.user_status==='inactive') {
            user=false;
            await userService.logout()
            clearAuthSession();
            setAuthItem('custom-status', 'inactive');
            setTimeout(() => {
                window.location.reload();
            }, 500);
        } 
    }catch (e) {
        if (e.response?.status === 401 || e.response?.status === 403) {
            user = false;
            clearAuthSession();
            setTimeout(() => {
                window.location.reload();
            }, 500);
        } else {
            // Transient failure (network blip / request aborted by a page refresh).
            // Treating it as an invalid user wiped the session via clearAuthSession()
            // in initializeSession (EE-2587). Keep the session — a genuinely dead
            // session is still caught by the inactive/401/403 branches above on the
            // next successful response.
        }
    }
    return user

}
   

        

    





